module.exports = __webpack_public_path__ + "static/media/2arsfabtext.b9802b44.jpg";